module.exports = __webpack_public_path__ + "03_bob_brown.aaaa10aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/03_bob_brown.png
// module id = siVR
// module chunks = 0